var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-2xl text-on-primary bg-primary rounded-full bg-white flex items-center justify-center mr-4 relative",class:{
        'w-16 h-16': !_vm.isRemaining,
        'w-12 h-12 opacity-25': _vm.isRemaining,
    }},[_vm._v(" "+_vm._s(_vm.step)+" "),(_vm.isRemaining)?_c('span',{staticClass:"step-connector hidden sm:block absolute bg-primary"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }